<template>
  <div id="custom_template" class="wrap">
    <div class="mobileOnly">
      <div class="logo">
        <img src="./assets/images/langham-london-logo.jpg" class="logo" />
      </div>
      <div class="bg-show mobileOnly" style="z-index: 100">
        <ul>
          <li class="testClick" data-language="english" @click="setLang('eng')">
            Eng
          </li>
          <li
            class="testClick"
            data-language="chineseTrad"
            @click="setLang('trad')"
          >
            繁
          </li>
          <li
            class="testClick"
            data-language="chinese"
            @click="setLang('simp')"
          >
            简
          </li>
        </ul>
      </div>
    </div>
    <div class="header">
      <img src="./assets/images/newheader.jpg" />
    </div>
    <div class="content-wrap">
      <div class="bg-show desktopOnly" style="z-index: 100">
        <ul class="translate-nav">
          <li class="testClick" data-language="english" @click="setLang('eng')">
            Eng
          </li>
          <li
            class="testClick"
            data-language="chineseTrad"
            @click="setLang('trad')"
          >
            繁
          </li>
          <li
            class="testClick"
            data-language="chinese"
            @click="setLang('simp')"
          >
            简
          </li>
        </ul>
      </div>
      <div class="content">
        <div id="formWrap">
          <h3
            style="
              text-transform: uppercase;
              font-size: 20px;
              font-family: none;
              font-weight: normal;
              font-size: 18px;
            "
            class="mobileOnlyHeader replaceMe"
          >
            Welcome to the Langham
          </h3>
          <form
            id="lastNameOrAccessCodeForm"
            style="position: relative;"
          >
            <div class="left-content">
              <p class="replaceMe" id="greetingText" style="font-size: 18px">
                We are pleased to offer internet throughout your stay so that
                you may stay connected to the world.
              </p>
              <br /><br />
              <input
                type="hidden"
                name="authenticate"
                id="authenticate"
                value="false"
              />
              <input type="hidden" name="rate_plan" id="rate_plan" value="91" />
              <div class="radioButtons">
                <input
                  type="radio"
                  name="regMethod"
                  value="resident"
                  v-model="form.reg_method"
                />&nbsp;
                <label class="replaceMe mobileOnlyFontSize"
                  >Resident Guests</label
                >
                &nbsp;
                <input
                  type="radio"
                  name="regMethod"
                  value="nonResident"
                  v-model="form.reg_method"
                />
                &nbsp;
                <label class="replaceMe mobileOnlyFontSize"
                  >Non-Resident Guests</label
                >
              </div>
              <table class="table mt20">
                <tbody>
                  <tr class="residentRow">
                    <td class="label inputTd">
                      <span class="replaceMe">Room Number</span>
                      &nbsp;
                      <input
                        type="text"
                        name="room_number"
                        id="room_number"
                        class="roomNumber"
                        value=""
                        v-model="form.room_number"
                      />
                      &nbsp;
                      <div class="mobileOnly"><br /><br /></div>
                      <span class="lastNameLabel mobile"
                        ><br><span class="replaceMe">Last Name</span>
                        &nbsp;
                        <input
                          type="text"
                          name="last_name"
                          id="last_name"
                          class="lastName"
                          value=""
                          v-model="form.last_name"
                      /></span>
                    </td>
                  </tr>
                  <tr class="nonResidentRow" style="display: none">
                    <td class="label inputTd">
                      <span class="replaceMe">Access Code:</span>
                      <input
                        type="text"
                        name="access_code"
                        id="access_code"
                        class=""
                        value=""
                        v-model="form.access_code"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="button m0">
                        <input
                          type="submit"
                          name="continue"
                          id="continueButton"
                          value="CONNECT"
                          @click="emitRegistrationMethodData()"
                        />
                      </div>
                    </td>
                    <td colspan="2">&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <div id="toc">
                        <span v-if="checkLang('eng')">
                          By clicking "CONNECT", you hereby agree with all the
                          <a @click="toggleToc()">terms and conditions</a> for
                          the use of the internet.
                        </span>
                        <span v-if="checkLang('trad')">
                          點擊連接即表示您同意所有
                          <a @click="toggleToc()">條款和條件</a>
                          使用互聯網的認同
                        </span>
                        <span v-if="checkLang('simp')">
                          点击連接，您在此的所有<a @click="toggleToc()"
                            >条款和条件</a
                          >
                          使用互联网的认同</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="checkLang('eng') && tocStatus()" class="toc">
                <p>
                  To begin using your Internet access, please confirm your
                  acceptance of the terms and conditions listed. The broadband
                  internet access service is a high tech communication tool and
                  is significantly vulnerable and constrained to the internal
                  and external environment. Users should fully understand the
                  potential risks of using this service, including but not
                  limited to:
                </p>
                <p>
                  1.Infringing of benefits, patent, copyright, business secrets
                  or intellectual properties related to third parties;
                </p>
                <p>
                  2.The accuracy, confidentiality, comprehensiveness,
                  punctuality, continuity and the safety of the system may be
                  jeopardized;
                </p>
                <p>
                  3.Improper use or handling of the system may lead to file data
                  loss due to direct, indirect, occasional, specific causes;
                </p>
                <p>
                  4.Temporary power off, unstable electricity current, damages
                  to the electricity or communication cables and equipment.
                </p>
              </div>
              <div v-if="checkLang('trad') && tocStatus()" class="toc">
                <p>
                  酒店提供上網服務供您使用，請點擊“接受”說明已知悉並接受此條款。
                  由於寬帶上網涉及高端通訊技術要求及受多種外圍因素制約，服務極易受到幹擾，請用戶清楚及了解有關使用風險，我們對使用此網絡造成損失不承擔任何責任，包括且不限於：
                </p>
                <p>1．第三者之專利，特許，版權，商業秘密，知識產權等；</p>
                <p>
                  2．寬帶上網服務之全面性, 保密性, 準確性, 及時性,
                  連續性及安全性等;
                </p>
                <p>
                  3．在任何情況下, 直接, 間接, 偶然,
                  特殊原因造成的文件損壞或數據丟失;
                </p>
                <p>
                  4．對電源供應中斷, 電壓不穩,
                  電纜或通訊設備等損壞所造成的寬帶上網服務異常;
                </p>
              </div>
              <div v-if="checkLang('simp') && tocStatus()" class="toc">
                <p>
                  酒店提供上网服务供您使用，请点击“接受”说明已知悉并接受此条款。
                  由于宽带上网涉及高端通讯技术要求及受多种外围因素制约，服务极易受到干扰，请用户清楚及了解有关使用风险，我们对使用此网络造成损失不承担任何责任，包括且不限于：
                </p>
                <p>1．第三者之专利，特许，版权，商业秘密，知识产权等；</p>
                <p>
                  2．宽带上网服务之全面性, 保密性, 准确性, 及时性,
                  连续性及安全性等;
                </p>
                <p>
                  3．在任何情况下, 直接, 间接, 偶然,
                  特殊原因造成的文件损坏或数据丢失;
                </p>
                <p>
                  4．对电源供应中断, 电压不稳,
                  电缆或通讯设备等损坏所造成的宽带上网服务异常;
                </p>
              </div>
            </div>
            <div id="press_img" style="" v-if="!tocStatus()">
              <ul>
                <li>
                  <a href="http://chat.langhamhotels.com/the-langham-chicago-WEB">
                    <img style="width: 120px;" src="./assets/images/qr/qr-chi.png" />
                    <p class="replaceMe" style="display: inline">
                      Scan the QR code or tap here to connect with a member of
                      our team.
                    </p>
                  </a>
                </li>
                <li>
                  <img
                    v-if="doc.selected_language === 'eng'"
                    style="width: 100%"
                    src="./assets/images/press_img/media-english.jpg"
                  />
                  <img
                    v-if="doc.selected_language === 'trad'"
                    style="width: 100%"
                    src="./assets/images/press_img/media-traditional.jpg"
                  />
                  <img
                    v-if="doc.selected_language === 'simp'"
                    style="width: 100%"
                    src="./assets/images/press_img/media-simplified.jpg"
                  />
                </li>
              </ul>
            </div>
            <div class="desktopOnly logo">
              <img src="./assets/images/langham-london-logo.jpg" class="" />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>

    <div class="device-info" v-if="!tocStatus()">
      <!--<b>My Device:</b> <span id="my_ip">192.168.0.190</span> <span>-</span>
      <span id="my_mac">99:88:77:66:55:44</span><br /><br /><br />-->
      <b>24/7 Internet Support:</b> (866) 368-6310


    </div>
  </div>
</template>
<script>
import $ from "jquery";
import RegistrationMethod from "@/components/PortalRegistrationMethod";
export default {
  name: "custom_template",
  props: ["portal", "connection_data"],
  components: {
    "registration-method": RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    "doc.selected_rm": function () {
      this.doc.selected_tos = null;
    },
  },
  data() {
    return {
      access_code: null,
      access_code_valid: true,
      access_code_error_text: "Required",
      form: {
        reg_method: "resident",
        last_name: "",
        room_number: "",
        access_code: "",
      },
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        selected_language: "eng",
        support_phone: "8772822519",
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    };
  },
  filters: {
    phone: function (value) {
      if (!value) return "";
      value = value.toString();
      return (
        "(" +
        value.substr(0, 3) +
        ") " +
        value.substr(3, 3) +
        "-" +
        value.substr(6, 4)
      );
    },
  },
  mounted() {
    if (this.portal.template.support_phone) {
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();

    /** Page jQuery */
    $(document).ready(function () {
      $("tr.nonResidentRow").hide();
      $("input[type=radio][name=regMethod]").change(function () {
        if (this.value == "resident") {
          $("tr.residentRow").show();
          $("tr.nonResidentRow").hide();
        } else if (this.value == "nonResident") {
          $("tr.nonResidentRow").show();
          $("tr.residentRow").hide();
        }
      });

      var tocLink = "/View/0a72f4/default_toc" + window.location.search;

      var langEnglish = [
        "Welcome to the Langham",
        "We are pleased to offer internet throughout your stay so that you may stay connected to the world.",
        "Resident Guests",
        "Non-Resident Guests",
        "Room Number",
        "Last Name",
        /*'OR',*/
        "Access Code",
        /*'By clicking "CONNECT", you hereby agree with all the <a href="' +
          tocLink +
          '">terms and conditions</a> for the use of the internet.',*/
        "Scan or click on the QR code to connect with a member of our team.",
      ];

      var langChinese = [
        "欢迎到朗廷酒店",
        "为确保您与我们的住宿愉快，我们很高兴在您入住期间为您提供免费上网，让您与世界保持联系",
        "住店客人",
        "非住店客人",
        "房间号",
        "姓",
        /*'要么',*/
        "访问代码",
        /*'点击連接，您在此的所有<a href="' +
          tocLink +
          '&CH">条款和条件</a>使用互联网的认同',*/
        "扫描或点击二维码联系我们",
      ];

      var langChineseTrad = [
        "歡迎到朗廷酒店",
        "為確保您與我們的住宿愉快，我們很高興在您入住期間為您提供免費上網，讓您與世界保持聯繫",
        "住店客人",
        "非住店客人",
        "房間號",
        "姓",
        /*'要么',*/
        "訪問代碼",
        /*'點擊連接即表示您同意所有<a href="' +
          tocLink +
          '&CHT">條款和條件</a>使用互聯網的認同',*/
        "掃描或點擊二維碼與我們的團隊成員聯繫。",
      ];
      $("#continueButton").on("click", function (e) {
        e.preventDefault();
      });
      $(".testClick").on("click", function (e) {
        var toLang = $(e.target).data("language");

        if (toLang === "chinese") {
          $(".replaceMe").each(function (i, item) {
            $(item).html(langChinese[i]);
          });

          $("#continueButton").val("連接");
        } else if (toLang === "chineseTrad") {
          $(".replaceMe").each(function (i, item) {
            $(item).html(langChineseTrad[i]);
          });
          $("#continueButton").val("連接");
        } else {
          $(".replaceMe").each(function (i, item) {
            $(item).html(langEnglish[i]);
          });

          $("#continueButton").val("CONNECT");
        }
      });
    });
  },
  methods: {
    generateRegistrationMethods: function () {
      for (var i in this.portal.registration_methods) {
        var rm = this.portal.registration_methods[i];
        for (var c in rm.rate_plans) {
          var rateplan = rm.rate_plans[c];
          var plan = {
            name:
              rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: "rateplan",
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if (this.portal.access_codes.length > 0) {
        plan = {
          name: "Access Code",
          type: "accesscode",
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if (this.registration_methods.length == 1) {
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function (index) {
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function (index) {
      this.doc.selected_tos = index;
    },
    setLang: function (lang) {
      this.doc.selected_language = lang;
      // change the language for each registration method component
      // this.$refs.registration_method.map((method) => method.setLang(lang));
    },
    checkLang: function (lang) {
      return lang == this.doc.selected_language;
    },
    tocStatus: function () {
      return this.doc.selected_tos;
    },
    toggleToc: function (lang) {
      if (!this.doc.selected_tos) {
        this.doc.selected_tos = true;
      } else {
        this.doc.selected_tos = false;
      }
    },
    // Send registration method details back to parent
    emitRegistrationMethodData: function () {
      if (this.form.reg_method === "resident") {
        this.registration_method = this.registration_methods[0];
      }
      if (this.form.reg_method === "nonResident") {
        this.registration_method = this.registration_methods[1];
      }
      this.access_code = this.form.access_code;
      // If no access code set, show required text
      if (this.registration_method.type == "accesscode" && !this.access_code) {
        this.access_code_valid = false;
        console.log(this.access_code);
        return;
      }
      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };
      console.log(this.registration_method);
      if (this.registration_method.registration_method_id == "1") {
        emitted.rateplan_id = this.registration_method.id;
      } else if (this.registration_method.registration_method_id == "2") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if (this.registration_method.registration_method_id == "3") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if (this.registration_method.registration_method_id == "4") {
        emitted.access_code = this.access_code;
      }
      console.log(emitted);
      this.$emit("emitRegistrationMethodData", emitted);
    },
  },
};
</script>

<style >
@import url("//fonts.googleapis.com/css?family=Quattrocento");
@import url("//fonts.googleapis.com/css?family=Noto+Sans+SC");
@import url("//fonts.googleapis.com/css?family=Noto+Sans+TC");
/**Start accounting for different parent div structures */
/*#dynamic-template{
  width: 100%;
}*/
/** End account for different parent div structures */
html,
body,
#app,
#connect,
#dynamic-template {
  all: unset;
}
span {
  all: unset;
}
input {
  border: 1px solid black;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td,
img {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
q:before,
q:after {
  content: "";
}
abbr,
acronym {
  border: 0;
}
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
q,
small,
strong,
sub,
sup,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  border: 0;
  margin: 0;
  padding: 0;
}
article,
aside,
figure,
figure img,
figcaption,
hgroup,
footer,
header,
nav,
section,
video,
object {
  display: block;
}
a img {
  border: 0;
}
figure {
  position: relative;
}
figure img {
  width: 100%;
}

body {
  width: 100%;
  background: white;
  font-size: 12px;
  line-height: 15px;
  font-family: Arial, sans-serif;
  color: #6b6b6b;
  text-align: center;
}

textarea,
input[type="text"],
input[type="button"],
input[type="submit"] {
  -webkit-appearance: none;
  border-radius: 0;
}

a:link,
a:visited {
  color: #444444;
}
a:hover {
  color: #818181;
}

.loading {
  clear: both;
  float: left;
  width: 100%;
  height: 48px;
  background: url(/images/loading-sm.gif) top center no-repeat transparent;
}

.wrap {
  width: 620px;
  margin: 0 auto 30px;
  padding: 30px 0 0;
  text-align: left;
  background: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.35);
}
.header {
  width: 620px;
  clear: both;
  float: left;
  padding: 10px 0;
  text-align: center;
}

.content-wrap {
  width: 620px;
  clear: both;
  float: left;
}
.content-left,
.content-right {
  width: 450px;
  overflow: hidden;
}
.content-left {
  float: left;
  margin-left: 20px;
}
.content-right {
  float: right;
  margin-right: 20px;
}
.content-left h3,
.content-right h3 {
  margin-left: 0;
  margin-right: 0;
}

.wrap-old {
  width: 620px;
  margin: 30px auto;
  padding: 0 10px;
  text-align: left;
}
.wrap-old .header,
.wrap-old .content-wrap {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.35);
}
.wrap-old .header {
  padding: 0;
  margin-bottom: 20px;
}
.wrap-old .header .logo {
  float: left;
}
.wrap-old .header .logo img {
  margin: 14px 14px 12px;
}
.wrap-old .header .slogan-wrap {
  float: right;
}
.wrap-old .header .slogan {
  margin: 48px 20px 0 0;
  font-size: 22px;
  text-align: right;
}

.clearfix {
  clear: both;
  height: 1px;
  overflow: hidden;
}

.table {
  width: 100%;
}
.table tr td {
  padding: 2px 5px;
}
.label {
}

.toc-input {
  text-align: right;
}
.toc-text {
  text-transform: uppercase;
  font-weight: bold;
}

.text-wrap {
  float: left;
  clear: both;
  width: 580px;
  margin: 0 0 20px 0;
  padding: 0 20px;
}
.text-wrap-end {
  margin: 0;
}
.text-wrap p {
  line-height: 1.4em;
}

#rate_plan_td ol {
  padding: 5px 0;
  list-style-type: decimal;
}
#rate_plan_td ol li {
  margin: 0 0 10px 22px;
  font-size: 16px;
}
#rate_plan_td ol li:last-child {
  margin-bottom: 0;
}

.rate-plan {
  display: block;
  width: 580px;
  background: #ebeae6;
  padding: 20px 0;
  margin: 0 auto 20px auto;
  text-align: center;
}
.rate-plan-option {
  cursor: pointer;
}
.rate-plan-option:hover {
  background: #d2e5fa;
}
.rate-plan:last-child {
  margin: 0;
}
.rate-plan .price {
  font-size: 1.1em;
  font-weight: bold;
}
.rate-plan .title {
  font-size: 1.2em;
  font-weight: bold;
}
.rate-plan-selected {
  background: #dcebb2 !important;
  box-shadow: inset 0 0 0 6px rgba(195, 235, 96, 0.7);
}
.rate-plan-selected:hover {
  background: #dcebb2 !important;
}

.rate_plan {
  display: inline-block;
  width: 100%;
  font-size: 16px;
  padding: 10px;
  margin: 0;
  background: #e8e8e8;
  color: #6b6b6b;
  border: 1px solid #e8e8e8;
  text-align: left;
}
.text {
  width: 240px;
  font-size: 16px;
  padding: 10px;
  background: #e8e8e8;
  color: #6b6b6b;
  border: 1px solid #e8e8e8;
  text-align: left;
}
.mini {
  width: 60px;
}

.button {
  display: block;
  float: left;
  clear: both;
  margin: 0 20px;
}
.button-end {
  margin-top: 20px;
}
.button input {
  width: 100%;
  margin: 0;
  min-height: 36px;
}
.button-small {
  width: 100%;
  margin: 0;
}
.button input.button-half {
  width: 285px;
}
.button input.button-half:last-child {
  float: right;
}

h3 {
  clear: both;
  display: block;
  width: 580px;
  margin: 0 20px 20px 20px;
  padding-top: 20px;
  line-height: 1.5em;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #dcdcdc;
}
p {
  margin: auto 10px;
}
.mb0 {
  margin-bottom: 0;
}
.mt20 {
  margin-top: 20px;
}

#table-devices {
  width: 100%;
  margin-top: 20px;
}

#table-devices tr td {
  padding: 3px 5px;
}

#table-devices tbody tr:nth-child(odd) {
  background: #ebeae6;
}

#table-devices thead tr td {
  font-weight: bold;
}

#table-devices tr td.idx {
  width: 10px;
  text-align: center;
}

#table-devices tr td.action {
  width: 10px;
  text-align: center;
  cursor: pointer;
}

#table-upgrade {
  width: 580px;
  margin: 0 20px;
  font-size: 12px;
}

#table-upgrade thead tr td {
  padding: 0 0 5px 0;
  font-weight: bold;
}

#table-upgrade tfoot tr td {
  padding: 5px 0 0 0;
  font-weight: bold;
}

#table-upgrade tr td:last-child {
  text-align: right;
}

#table-upgrade tbody tr td {
  padding: 5px 0;
}

.errors {
  display: block;
  width: 565px;
  margin: 0 20px 20px 20px;
  padding-left: 15px;
  list-style: disc inside;
}
.errors li {
}

.toc-agree {
  clear: both;
  margin: 0 0 10px 0;
  padding: 0 20px;
  font-size: 11px;
  font-weight: bold;
  text-align: left;
  text-transform: uppercase;
}
.toc-agree input {
  margin-right: 5px;
}

.device-info {
  float: left;
  width: 300px;
  margin: 20px 0 10px 20px;
  padding: 10px 0 0 0;
  border-top: 1px solid #dcdcdc;
}

.support-info {
  float: right;
  width: 280px;
  margin: 20px 20px 10px 0;
  padding: 10px 0 0 0;
  border-top: 1px solid #dcdcdc;
  text-align: right;
}

.footer {
  float: left;
  clear: both;
  margin: 20px;
}

#timeRemaining {
  display: block;
  width: 580px;
  height: 30px;
  margin: 0 20px;
  padding: 25px 0 20px;
}
#upgradeButton {
  cursor: pointer;
}

/* jQuery Countdown styles 1.6.1. */
.hasCountdown {
  background-color: #ebeae6;
}
.countdown_rtl {
  direction: rtl;
}
.countdown_holding span {
  color: #6b6b6b;
}
.countdown_row {
  clear: both;
  width: 100%;
  padding: 0px 2px;
  text-align: center;
}
.countdown_show1 .countdown_section {
  width: 98%;
}
.countdown_show2 .countdown_section {
  width: 48%;
}
.countdown_show3 .countdown_section {
  width: 32.5%;
}
.countdown_show4 .countdown_section {
  width: 24.5%;
}
.countdown_show5 .countdown_section {
  width: 19.5%;
}
.countdown_show6 .countdown_section {
  width: 16.25%;
}
.countdown_show7 .countdown_section {
  width: 14%;
}
.countdown_section {
  display: block;
  float: left;
  font-size: 100%;
  text-align: center;
}
.countdown_amount {
  font-size: 200%;
  font-weight: normal;
}
.countdown_descr {
  display: block;
  width: 100%;
}

@media screen and (max-width: 640px) {
  .wrap {
    display: block;
    width: 100%;
    margin: 0 0 10px;
    padding: 30px 0 0;
    text-align: left;
    overflow: hidden;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .loading {
    margin-bottom: 20px;
  }
  .header,
  .content-wrap {
    width: 100%;
    clear: both;
    float: left;
    border-radius: 0;
    box-shadow: none;
  }

  .wrap-old {
    display: block;
    width: 100%;
    margin: 30px 0 0;
    padding: 0;
    text-align: left;
    overflow: hidden;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .wrap-old .header,
  .wrap-old .content-wrap {
    border-radius: 0;
    box-shadow: none;
  }
  .wrap-old .header .logo,
  .wrap-old .header .slogan-wrap,
  .wrap-old .header .slogan-wrap .slogan {
    width: 100%;
    text-align: center;
  }
  .wrap-old .header .logo img {
    margin: 20px 0;
  }
  .wrap-old .header .slogan-wrap .slogan {
    padding: 0 0 20px 0;
    margin: 0;
  }

  .text-wrap {
    float: left;
    clear: both;
    width: 90% !important;
    margin: 0 5% 20px 5%;
    padding: 0;
    font-size: 16px;
  }
  .text-wrap-end {
    margin-bottom: 0;
  }
  .button {
    display: block;
    float: left;
    clear: both;
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    font-size: 16px;
  }
  .button input {
    min-height: 48px;
    font-size: 16px;
  }
  .button input.button-half {
    display: block;
    width: 100%;
  }
  .button input.button-half:last-child {
    margin-top: 20px;
  }
  .device-info {
    float: left;
    width: 90%;
    margin: 20px 5% 0 5%;
    padding: 10px 0 0 0;
    border-top: 1px solid #dcdcdc;
    text-align: center;
    font-size: 16px;
  }
  .support-info {
    float: right;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding: 10px 0 0 0;
    border-top: none;
    text-align: center;
    font-size: 16px;
  }
  .errors {
    display: block;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding-left: 0;
    list-style: disc inside;
    font-size: 16px;
  }
  .errors li {
    margin: 0 10px 20px 10px;
  }
  .errors li:last-child {
    margin-bottom: 0;
  }
  .text {
    width: 90%;
    font-size: 16px;
    padding: 10px 5%;
  }
  .mini {
    width: 60px;
  }
  .rate_plan {
    display: block;
    width: 100%;
    font-size: 16px;
    padding: 10px 0;
    margin: 0;
    line-height: 20px;
  }
  h3 {
    clear: both;
    display: block;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding-top: 20px;
    font-size: 20px;
  }
  #timeRemaining {
    display: block;
    width: 90%;
    margin: 0 5%;
    height: 30px;
    padding: 25px 0 20px;
    font-size: 120%;
  }
  .rate-plan {
    width: 90%;
    margin: 0 5% 20px;
    font-size: 16px;
  }
  #table-upgrade {
    width: 90%;
    margin: 0 5% 20px;
    font-size: 14px;
  }
  #table-devices tr td {
    padding: 10px;
  }
  .toc-agree {
    font-size: 12px;
  }
}

body {
  font-family: "Quattrocento", "Noto Sans SC", "Noto Sans TC";
  color: #000000;
}
.radioButtons,
#toc,
.label {
  font-weight: normal;
}
.wrap {
  border: none;
  box-shadow: none;
  width: 75%;
  margin: 0 auto;
  text-align: left;
  padding: 0;
}

.header {
  width: 100%;
  padding: 0;
  position: relative;
  clear: none;
  float: none;
}

.header img {
  max-width: 850px;
  width: 100%;
}

.content-wrap {
  width: 100%;
  clear: none;
  float: none;
  position: relative;
  max-width: 850px;
  margin: 0 auto;
}

.left-content {
  width: 60%;	
  padding-right: 10px;	
  float: left;
}

.bg-show {
  /*background: url(https://www.registerforhsia.com/hotels/langham/images/londonlogo.jpg) center no-repeat;*/
  display: block;
  width: 200px;
  height: 25px;
  position: absolute;
  right: 0;
  top: 25px;
}

.bg-show ul {
  /*padding-top: 5px;*/
  margin: 0 auto;
  text-align: center;
}

.bg-show ul li {
  display: inline-block;
  color: #000000;
  font-size: 1.5em;
  cursor: pointer;
  padding: 0 10px;
  border-right: 1px solid #ccc;
}

.bg-show ul li:last-child {
  border: none;
}

h3 {
  padding: 20px 0 5px 0;
  margin: 0;
  font-size: 2.5em;
  color: #888888;
  text-transform: none;
  border: none;
}

p {
  margin: 0;
  font-size: 1.25em;
  line-height: 1.3em;
}

.button {
  float: none;
  padding: 0;
  margin: 0;
}

.button input {
  width: 100%;
  max-width: 260px;
  border: none;
  margin: 20px 0 10px;
  background: #feeef2;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  opacity: 1;
}

.button input:hover {
  opacity: 0.8;
}
line.testClick {
  color: #000000;
}
#toc {
  /*width: 260px;*/
  font-size: 18px;
  line-height: 22px;
  text-align: left;
}

.device-info {
  float: none;
  width: 100%;
  padding: 20px 0;
  margin: 20px 0;
}
div.radioButtons {
  font-size: 1.1rem;
}

.table tr td:first-child {
  font-size: 18px;
}
input[type="text"] {
  background: #fff;
  border-width: 1px;
  border-style: inset;
  font-size: 14px;
}
input[type="text"].roomNumber {
  width: 100px;
}
input[type="text"].lastName {
  width: 150px;
}
#continueButton {
  width: 160px;
}
.mobileOnly {
  display: none;
}
#press_img {
  padding: 10px;	
  background: #efeeef;	
  width: 40%;	
  float: right;	
  z-index: 1;
}
#press_img li a { display: flex; align-items: center; text-decoration: none; }	
#press_img li a img { margin-right: 10px; }	
#press_img li:first-child { margin-bottom: 20px;}
.logo {
  text-align: center;
}

.desktopOnly.logo {
  clear: both
}
#toc a {
  color: blue;
}
/*.replaceMeTOC center{
    margin-bottom: 15px;
}
ul.translate-nav{
    margin-top: 15px;
}*/
/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
  #press_img {
    position: unset;
  }
  .wrap {
    width: 100%;
  }
  #formWrap {
    padding-left: none;
  }
  /*.header{
		margin-top: 180px;
	}*/
  .mobileOnly {
    display: none;
  }
  .desktopOnly {
    display: none;
  }

  /*tr.residentRow.desktop{
		display: none;
	}
	tr.residentRow.mobile{
		display: inline;
	}*/

  .content {
    padding: 0 30px;
  }
  /*input[type="text"].lastName{
		width: 80px;
	}
	input[type="text"].roomNumber{
		width: 30px;
    }*/
  .bg-show.mobileOnly {
    margin-top: 46px;
  }
  .bg-show {
    right: 0%;
    right: 10px;
  }
  .device-info {
    padding-left: 30px;
  }

  .header img {
    width: initial;
  }
  .header {
    margin-top: 18px;
  }
  .mobileOnly {
    display: inline;
  }
  .desktopOnly {
    display: none;
  }
  td.label.onlyTextInputs {
    float: left;
  }
  .lastNameLabel {
    padding-left: 14px;
  }
  table {
    text-align: center;
  }
  input[type="submit"] {
    margin-left: 25px;
  }
  div.desktopOnly.logo img {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .bg-show ul {
    text-align: right;
  }
}

@media only screen and (max-width: 700px) {
  /*body{
		width: 100%;
	}*/
  body {
    line-height: 7px;
  }
  .table tr td:first-child {
    font-size: 14px;
  }
  .table tr td {
    padding: 0;
  }
  .wrap {
    width: 100%;
  }
  img.logo {
    width: 40%;
  }
  .header {
  }
  label.mobileOnlyFontSize {
    font-size: 12px;
  }
  .left-content {
    width: 100%;	
    padding: 0 30px 30px 30px;	
    text-align: center;
  }
  #greetingText {
    padding-left: 10px;
  }
  .bg-show ul li {
    font-size: 1em;
  }
  .content {
    padding: 30px 0 0 0;
  }
  .mobileOnlyHeader {
    text-align: center;
    padding-top: 0;
    padding-right: 30%;
  }
  #formWrap {
    padding-left: 0;
  }

  .bg-show {
    /*right: 50%;*/
    margin-right: -100px;
    width: 100%;
  }
  .bg-show.mobileOnly {
    margin-right: 0px;
  }
  .lastNameLabel span {
    padding-right: 10px;
  }
  #last_name {
    width: 100px;
  }
  .radioButtons {
    padding-left: 30px;
  }
  .bg-show ul {
    width: 100%;
  }
  .device-info {
    display: none;
  }

  #toc {
    text-align: center;
  }

  h3 {
    width: 130%;
  }
  .header img {
    width: 130%;
  }
  #press_img {
    width: 130%;
  }
  #press_img img {
    width: 50%;
  }
  #press_img li {
    padding: 1rem;
  }
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 800px) {
  .wrap {
    width: 100%;
  }

  #lastNameOrAccessCodeForm {
    height: 580px !important;
  }
}
@media screen and (max-width: 320px) {
  .radioButtons{
    padding-left: 10px;
  }
}
</style>
